import { render, staticRenderFns } from "./param-std-proxy-form-items.vue?vue&type=template&id=7043e08a&scoped=true&"
import script from "./param-std-proxy-form-items.vue?vue&type=script&lang=ts&"
export * from "./param-std-proxy-form-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7043e08a",
  null
  
)

export default component.exports